// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadOptionCard-cls1_6EX","cls2":"DownloadOptionCard-cls2_36C DownloadOptionCard-cls1_6EX"};